import { FC } from "react";
import { useFormContext } from "react-hook-form";
import TGButton from "src/components/ui/TGButton";
import { IAnswer } from "../../../types";

interface IProps {
  editQuestion?: () => void;
}

const FormEditQuestionFooter: FC<IProps> = ({ editQuestion }) => {
  const {
    formState: { isValid, isDirty },
    getValues
  } = useFormContext();
  const answers = getValues("Answers");
  const disabledButton = !isValid || !isDirty || answers.length < 2 || !answers?.filter((answer: IAnswer) => answer.IsCorrect).length;

  return (
    <div className="flex justify-between gap-5">
      <TGButton type="button" onClick={editQuestion} className="w-1/2">
        Отменить изменения
      </TGButton>
      <TGButton type="submit" disabled={disabledButton} className="w-1/2" color="bluedark">
        Сохранить изменения
      </TGButton>
    </div>
  );
};
export default FormEditQuestionFooter;
